/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiAttachCasePersonsRequest,
    InternalApiAttachCasePersonsRequestFromJSON,
    InternalApiAttachCasePersonsRequestToJSON,
    InternalApiCasePersonPage,
    InternalApiCasePersonPageFromJSON,
    InternalApiCasePersonPageToJSON,
    InternalApiDetachCasePersonsRequest,
    InternalApiDetachCasePersonsRequestFromJSON,
    InternalApiDetachCasePersonsRequestToJSON,
    InternalApiSortDirection,
    InternalApiSortDirectionFromJSON,
    InternalApiSortDirectionToJSON,
} from '../models';

export interface AttachCasePersonsRequest {
    handle: string;
    internalApiAttachCasePersonsRequest: InternalApiAttachCasePersonsRequest;
}

export interface DetachCasePersonsRequest {
    handle: string;
    internalApiDetachCasePersonsRequest: InternalApiDetachCasePersonsRequest;
}

export interface FindCasePersonsPageRequest {
    handle: string;
    size: number;
    page: number;
    query?: string;
    orderBy?: string;
    direction?: InternalApiSortDirection;
}

/**
 * 
 */
export class CasePersonInternalApi extends runtime.BaseAPI {

    /**
     * Attaches persons to a case
     */
    async attachCasePersonsRaw(requestParameters: AttachCasePersonsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters.handle === null || requestParameters.handle === undefined) {
            throw new runtime.RequiredError('handle','Required parameter requestParameters.handle was null or undefined when calling attachCasePersons.');
        }

        if (requestParameters.internalApiAttachCasePersonsRequest === null || requestParameters.internalApiAttachCasePersonsRequest === undefined) {
            throw new runtime.RequiredError('internalApiAttachCasePersonsRequest','Required parameter requestParameters.internalApiAttachCasePersonsRequest was null or undefined when calling attachCasePersons.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/cases/{handle}/persons`.replace(`{${"handle"}}`, encodeURIComponent(String(requestParameters.handle))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiAttachCasePersonsRequestToJSON(requestParameters.internalApiAttachCasePersonsRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Attaches persons to a case
     */
    async attachCasePersons(requestParameters: AttachCasePersonsRequest, initOverrides?: RequestInit): Promise<Array<string>> {
        const response = await this.attachCasePersonsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Detaches persons from a case
     */
    async detachCasePersonsRaw(requestParameters: DetachCasePersonsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.handle === null || requestParameters.handle === undefined) {
            throw new runtime.RequiredError('handle','Required parameter requestParameters.handle was null or undefined when calling detachCasePersons.');
        }

        if (requestParameters.internalApiDetachCasePersonsRequest === null || requestParameters.internalApiDetachCasePersonsRequest === undefined) {
            throw new runtime.RequiredError('internalApiDetachCasePersonsRequest','Required parameter requestParameters.internalApiDetachCasePersonsRequest was null or undefined when calling detachCasePersons.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/cases/{handle}/persons`.replace(`{${"handle"}}`, encodeURIComponent(String(requestParameters.handle))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiDetachCasePersonsRequestToJSON(requestParameters.internalApiDetachCasePersonsRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Detaches persons from a case
     */
    async detachCasePersons(requestParameters: DetachCasePersonsRequest, initOverrides?: RequestInit): Promise<void> {
        await this.detachCasePersonsRaw(requestParameters, initOverrides);
    }

    /**
     * Fetches paginated persons associated with a case
     */
    async findCasePersonsPageRaw(requestParameters: FindCasePersonsPageRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiCasePersonPage>> {
        if (requestParameters.handle === null || requestParameters.handle === undefined) {
            throw new runtime.RequiredError('handle','Required parameter requestParameters.handle was null or undefined when calling findCasePersonsPage.');
        }

        if (requestParameters.size === null || requestParameters.size === undefined) {
            throw new runtime.RequiredError('size','Required parameter requestParameters.size was null or undefined when calling findCasePersonsPage.');
        }

        if (requestParameters.page === null || requestParameters.page === undefined) {
            throw new runtime.RequiredError('page','Required parameter requestParameters.page was null or undefined when calling findCasePersonsPage.');
        }

        const queryParameters: any = {};

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.orderBy !== undefined) {
            queryParameters['orderBy'] = requestParameters.orderBy;
        }

        if (requestParameters.direction !== undefined) {
            queryParameters['direction'] = requestParameters.direction;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/cases/{handle}/persons`.replace(`{${"handle"}}`, encodeURIComponent(String(requestParameters.handle))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiCasePersonPageFromJSON(jsonValue));
    }

    /**
     * Fetches paginated persons associated with a case
     */
    async findCasePersonsPage(requestParameters: FindCasePersonsPageRequest, initOverrides?: RequestInit): Promise<InternalApiCasePersonPage> {
        const response = await this.findCasePersonsPageRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
